// This puts jquery against the global scope, to allow non-webpack module scripts to access jquery
window['jQuery'] = window['$'] = require('jquery');

import '../sass/main.scss';

// add vendor files
import 'popper.js';
import 'bootstrap';
import 'select2';

// add rl files
import './rl-Global';
import './rl-ButtonBlock';
import './rl-Burger';
import './rl-MegaMenu';
import './rl-BreadCrumbs';

import './rl-FeaturedBanner';
import './rl-PromoFeatureBanner';

import './rl-LazyLoad';
import './rl-SliderBlock';
import './rl-RichText';
import './rl-Tables';
import './rl-TabbedPanel';
import './rl-Cards';
import './rl-MultiAsset';
import './rl-VideoVimeo';
import './rl-VideoYouTube';
import './rl-VideoCommon';
import './rl-ContentLoadSelector';
import './rl-LinkSelector';
import './rl-FeaturedArticle.js';
import './rl-CookiesRLVisit';
import './rl-CookiesCampaign';
import './rl-Cookies';
import './rl-Search';
import './rl-SupportedBrowsers';
import './rl-DynamicPhone';
import './rl-EmergencyModal';
import './rl-Scroll';
import './rl-QuickNav';
import './rl-FixedCTA';
import './rl-Accordion';
import './rl-PDFFilterBlock';
import './rl-SmoothScroll';
import './rl-Quiz';
import './rl-PreviewPanel';
import './rl-ListingsBlock';
import './rl-EpiserverForm';
import './rl-InPageNavBlock';
import './rl-HoriTabbedPanel';
import './rl-EmbedInfoGraphic';
import './rl-ImageBlock';
import './rl-ReasonWhy';
import './rl-IFrame';
import './rl-SiteNotice';
import './rl-ContactBlock';
import './rl-IESpecific';